import { TennisResultsCategoriesProps } from "@sky-it-livedata/livedata-sports-design-system";
import { CreateSdapiResultsCategoriesWidgetInputSchema } from "appsync";
import { ResultsCategoriesData } from "../types";
import {
  cagetoriesMapGranSlam,
  categoriesMap,
} from "../../../utils/categoriesMap";
import { ErrorName, WidgetError } from "../../../utils/errors";

const isValidObject = (obj: ResultsCategoriesData) =>
  Boolean(obj?.data?.getSdapiResultsCategoriesWidget);

type Categories = TennisResultsCategoriesProps["categories"];
type Adv = TennisResultsCategoriesProps["adv"];

export const transformQuery = (
  obj: ResultsCategoriesData
): TennisResultsCategoriesProps => {
  if (isValidObject(obj)) {
    CreateSdapiResultsCategoriesWidgetInputSchema().parse(obj.data.getSdapiResultsCategoriesWidget, {reportInput: true});
    const widget = obj?.data?.getSdapiResultsCategoriesWidget!;
    const categories = (widget?.categories || []) as Categories;
    const { link, image } = widget?.adv || {};
    return {
      adv: link ? ({ link, image } as Adv) : undefined,
      targetSelector: "ld-tennis-sdapi-results",
      categories: categories?.map((category) => ({
        ...category,
        name: category.name,
        label: getCategoryName(category.name, widget.tournamentType),
      })),
      initialIndex: 0,
      setDefaultIndex: () => { },
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in ResultsCategories object',
      data: obj
    });
  }
};

function getCategoryName(name: string, tournamentType?: string) {
  if (tournamentType === "GrandSlam") {
    return (
      cagetoriesMapGranSlam[name as keyof typeof cagetoriesMapGranSlam] || name
    );
  }
  return categoriesMap[name as keyof typeof categoriesMap] || name;
}
